<template>
  <div class="register-progress-point">
    <div class="register-progress-point__number">
      <div class="register-progress-point__number__value" :class="{'register-progress-point__filled': filled}">{{
          number
        }}
      </div>
      <div :class="{'register-progress-point__number__bar': number != from,
      'register-progress-point__number__invisible': number == from}"></div>
    </div>
    <div class="register-progress-point__content">
      <h3 class="register-progress-point__content__title">{{ title }}</h3>
      <p class="register-progress-point__content__body">{{ body }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressPoint",
  props: {
    'number': Number,
    'from': Number,
    'title': String,
    'body': String,
    'filled': Boolean
  },
  setup () {

  }
}
</script>

<style scoped>

</style>